import React, { createContext, useState } from "react";
import PropTypes from "prop-types";
import { talukasListApi, memberList, villagesListApi, districtsListApi } from "Apis/member";
import { occupationListApi } from "Apis/member";
import { educationListApi } from "Apis/member";
import { settingListApi } from "Apis/settings";
import { getJsonData } from "Apis/utils";

export const MemberContext = createContext();

export const MemberContextProvider = ({ children }) => {
  const [districtsList, setDistrictsList] = useState([]);
  const [talukasList, setTalukasList] = useState([]);
  const [nativeTalukasList, setNativeTalukasList] = useState([]);
  const [villagesList, setVillagesList] = useState([]);
  const [nativeVillagesList, setNativeVillagesList] = useState([]);
  const [educationsList, setEducationsList] = useState([]);
  const [occupationsList, setOccupationsList] = useState([]);
  const [parentMemberList, setParentMemberList] = useState([]);
  const [settingList, setsettingList] = useState([]);
  const [currentSelectedMember, setCurrentSelectedMember] = useState();
  const [relationData, setRelationData] = useState([]);
  const [bloodGroupData, setBloodGroupData] = useState([]);
  const [maritalStatusData, setMaritalStatusData] = useState([]);
  const [generalOccupationsList, setGeneralOccupationsList] = useState([]);

  // District Listening
  const districtListing = async () => {
    let data = await districtsListApi();
    if (data?.status === 200) {
      const districtOptions = data?.data?.data?.rows?.map((district) => ({
        label: district.name,
        value: district.id,
      }));
      setDistrictsList(districtOptions);
    }
  };

  // Taluka Listening with filter
  const talukaListing = async (value) => {
    let data = await talukasListApi(value);
    if (data?.status === 200) {
      const talukaOptions = data?.data?.data?.rows?.map((taluka) => ({
        label: taluka.name,
        value: taluka.id,
      }));
      setTalukasList(talukaOptions);
    }
  };

  // Taluka Listening with filter for native
  const nativeTalukaListing = async (value) => {
    let data = await talukasListApi(value);
    if (data?.status === 200) {
      const talukaOptions = data?.data?.data?.rows?.map((taluka) => ({
        label: taluka.name,
        value: taluka.id,
      }));
      setNativeTalukasList(talukaOptions);
    }
  };

  // Village Listening with filter
  const villageListing = async (value) => {
    let data = await villagesListApi(value);
    if (data?.status === 200) {
      const villageOptions = data?.data?.data?.rows?.map((village) => ({
        label: village.name,
        value: village.id,
      }));
      setVillagesList(villageOptions);
    }
  };

  // Village Listening with filter for native
  const nativeVillageListing = async (value) => {
    let data = await villagesListApi(value);
    if (data?.status === 200) {
      const villageOptions = data?.data?.data?.rows?.map((village) => ({
        label: village.name,
        value: village.id,
      }));
      setNativeVillagesList(villageOptions);
    }
  };

  //  Parent Listing
  const parentDataListing = async () => {
    const response = await memberList({
      filters: {
        is_head_person: 1,
      },
    });
    if (response?.status === 200) {
      let members = [];
      response?.data?.data?.rows?.map((data) => {
        members.push({
          label: `(${data?.member_number}) ${data?.first_name} ${data?.middle_name} ${data?.surname}`,
          value: data?.id,
          first_name: data?.first_name,
          middle_name: data?.middle_name,
          email: data?.email,
          surname: data?.surname,
          imageUrl: data?.member_images[0]?.image,
        });
      });
      setParentMemberList(members);
    }
  };

  // Education Listing with filter
  const educationListing = async () => {
    let data = await educationListApi();
    if (data?.status === 200) {
      const educationOptions = data?.data?.data?.rows?.map((education) => ({
        label: education.name,
        value: education.id,
      }));
      setEducationsList(educationOptions);
    }
  };

  // Occupation Listing with filter
  const occupationListing = async () => {
    const data = await occupationListApi();
    if (data?.status === 200) {
      const allOccupations = data?.data?.data?.rows || [];

      const generalOccupations = allOccupations
        .filter((occupation) => occupation.is_general === 1)
        .map((occupation) => ({
          label: occupation.name,
          value: occupation.id,
        }));

      const otherOccupations = allOccupations
        .filter((occupation) => occupation.is_general === 0)
        .map((occupation) => ({
          label: occupation.name,
          value: occupation.id,
        }));

      setGeneralOccupationsList(generalOccupations);
      setOccupationsList(otherOccupations);
    }
  };

  // Setting Listing
  const settingListing = async () => {
    let data = await settingListApi();
    if (data?.status === 200) {
      const settingOption = data?.data?.data?.rows?.map((item) => ({
        label: item.name,
        value: item.value,
      }));
      setsettingList(settingOption);
    }
  };

  // Json Listing
  const jsonListing = async () => {
    let data = await getJsonData();
    if (data?.status === 200) {
      const relationDataOptions = data?.data?.data?.relationData?.map((relation) => ({
        label: relation.label,
      }));
      setRelationData(relationDataOptions);
      const bloodGroupOptions = data?.data?.data?.bloodGroupsData?.map((bloodGroup) => ({
        label: bloodGroup.label,
      }));
      setBloodGroupData(bloodGroupOptions);
      const maritalStatusOptions = data?.data?.data?.maritalStatusData?.map((maritalStatus) => ({
        label: maritalStatus.label,
      }));
      setMaritalStatusData(maritalStatusOptions);
    }
  };

  return (
    <MemberContext.Provider
      value={{
        districtListing,
        districtsList,
        setDistrictsList,
        talukaListing,
        talukasList,
        setTalukasList,
        villageListing,
        villagesList,
        setVillagesList,
        parentDataListing,
        parentMemberList,
        setParentMemberList,
        educationListing,
        occupationListing,
        educationsList,
        setEducationsList,
        occupationsList,
        setOccupationsList,
        currentSelectedMember,
        setCurrentSelectedMember,
        settingListing,
        settingList,
        setsettingList,
        relationData,
        setRelationData,
        bloodGroupData,
        maritalStatusData,
        setGeneralOccupationsList,
        generalOccupationsList,
        jsonListing,
        nativeTalukasList,
        setNativeTalukasList,
        nativeTalukaListing,
        nativeVillagesList,
        setNativeVillagesList,
        nativeVillageListing,
      }}
    >
      {children}
    </MemberContext.Provider>
  );
};

export default MemberContextProvider;
MemberContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
